export const config = {
	isURLHandlingEnabled: false,
	currency: 'Kč',
	scrollToElements: true,
	isOnlyOnlineBuyout: true,
	language: 'cs',
	international_phone_prefix: '+420',
	default_bank_code: '0300',
	router: null,
	swap_first_country: false,
	country_as_nationality: false,
	not_found_image: '/media/products/default.jpg',
	privacy_policy: {
		text: null,
		link_title: null,
		link: null
	},
	stores_link: null,
	accessoryCategoryChangedToSmartWatch: false,
	minimal_buyout_price: 10,
}
